// const CONTACTUS_REQUEST = "CONTACTUS_REQUEST";
// const CONTACTUS_SUCCESS = "CONTACTUS_SUCCESS"
// const CONTACTUS_FAIL = "CONTACTUS_FAIL"

// const PRODUCTREQ_REQUEST = "PRODUCTREQ_REQUEST";
// const PRODUCTREQ_SUCCESS = "PRODUCTREQ_SUCCESS"
// const PRODUCTREQ_FAIL = "PRODUCTREQ_FAIL"

export const ENQUIRIES_REQUEST = "ENQUIRIES_REQUEST";
export const ENQUIRIES_SUCCESS = "ENQUIRIES_SUCCESS"
export const ENQUIRIES_FAIL = "ENQUIRIES_FAIL"

